import { Flex } from 'antd'
import { FC, ReactNode, useContext, useState } from 'react'
import ToolingCostCheckbox from '../../../../components/tooling-cost-checkbox/tooling-cost-checkbox'
import CalculationPosition from '../../../../types/api/calculation-position'
import { CalculationPageCtx, CalculationToolingKind } from '../../calculations-page'

interface CalculationToolingCostCellProps {
    position: CalculationPosition
    kind: CalculationToolingKind
    value: ReactNode
}

function isIncluded(position: CalculationPosition, kind: CalculationToolingKind): boolean {
    const flag = kind === 'stamp' ? position.stampIncludedInCost : position.formsIncludedInCost
    return flag !== false
}

const CalculationToolingCostCell: FC<CalculationToolingCostCellProps> = ({
    position,
    kind,
    value,
}) => {
    const { onSetToolingIncluded } = useContext(CalculationPageCtx)
    const [pending, setPending] = useState(false)
    const included = isIncluded(position, kind)
    const disabled =
        pending || (kind === 'stamp' && !position.stamp?.documentId)

    const handleChange = async (nextIncluded: boolean) => {
        setPending(true)
        try {
            await onSetToolingIncluded(position, kind, nextIncluded)
        } finally {
            setPending(false)
        }
    }

    return (
        <Flex align='center' gap={4}>
            {value}
            <ToolingCostCheckbox included={included} disabled={disabled} onChange={handleChange} />
        </Flex>
    )
}

export default CalculationToolingCostCell
